export default {
    getList: {
        getPendList: async function (params) {
            let option = {
                url: '/api/v1/partner/user/details',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminPersonManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        resetPassword: async function (params) {
            let option = {
                url: '/api/v1/partner/user/' + params.id,
                type: 'patch',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminPersonManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    },
    do: {
        newPerson: async function (params) {
            let option = {
                url: '/api/v1/partner/user',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminPersonManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        editorPerson: async function (params) {
            let option = {
                url: '/api/v1/partner/user/' + params.id,
                type: 'put',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminPersonManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        deletePerson: async function (params) {
            let option = {
                url: '/api/v1/partner/user/' + params.id,
                type: 'delete',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminPersonManaging.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        }
    },
}